(() => {
  if (customElements.get('mm-free-shipping-progress')) return;
  const instances = new Set();
  let destination = null;
  const aliases = Object.fromEntries('AC:Acre|AL:Alagoas|AP:Amapá|AM:Amazonas|BA:Bahia|CE:Ceará|DF:Distrito Federal|ES:Espírito Santo|GO:Goiás|MA:Maranhão|MT:Mato Grosso|MS:Mato Grosso do Sul|MG:Minas Gerais|PA:Pará|PB:Paraíba|PR:Paraná|PE:Pernambuco|PI:Piauí|RJ:Rio de Janeiro|RN:Rio Grande do Norte|RS:Rio Grande do Sul|RO:Rondônia|RR:Roraima|SC:Santa Catarina|SP:São Paulo|SE:Sergipe|TO:Tocantins'.split('|').map(pair => {
    const [code, name] = pair.split(':');
    return [name.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''), code];
  }));
  const normalize = value => String(value || '').trim().toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const normalizeState = value => aliases[normalize(value)] || normalize(value);
  const isBrazil = value => ['BR', 'BRAZIL', 'BRASIL'].includes(normalize(value));
  const rememberDestination = address => {
    destination = {country: address.country || '', state: normalizeState(address.state)};
    try {
      // Only country and state persist for this browser session; no address or customer identity.
      window.sessionStorage.setItem('mm-free-shipping-destination', JSON.stringify(destination));
    } catch (_) {}
  };
  try {
    const saved = JSON.parse(window.sessionStorage.getItem('mm-free-shipping-destination') || 'null');
    if (saved && typeof saved.country === 'string' && typeof saved.state === 'string') {
      destination = {country: saved.country, state: normalizeState(saved.state)};
    }
  } catch (_) {}
  const handleChange = event => {
    const el = event.target;
    if (!el?.matches?.('.province-select, .country-select')) return;
    const container = el.closest('estimate-shipping-rate, .estimate-shipping-cart__wrapper');
    if (!container) return;
    window.setTimeout(() => {
      if (!el.isConnected) return;
      const country = container.querySelector('.country-select');
      const province = container.querySelector('.province-select');
      rememberDestination({country: country?.value || '', state: province?.value || ''});
      instances.forEach(instance => instance.update(destination));
    }, 0);
  };
  const handleDestination = event => {
    const address = event.detail;
    if (!address || !isBrazil(address.country)) return;
    rememberDestination({country: 'BR', state: address.state});
    instances.forEach(instance => instance.update(destination));
  };
  class MMFreeShippingProgress extends HTMLElement {
    connectedCallback() {
      this.messageEl = this.querySelector('[data-mm-fs-message]');
      this.trackEl = this.querySelector('[data-mm-fs-track]');
      this.fillEl = this.querySelector('[data-mm-fs-fill]');
      if (!this.messageEl || !this.trackEl || !this.fillEl) return;
      if (instances.size === 0) {
        document.addEventListener('change', handleChange);
        document.addEventListener('mm:shipping-destination', handleDestination);
      }
      instances.add(this);
      this.update(destination || {country: this.dataset.initialCountry || '', state: this.dataset.initialState || ''});
    }
    disconnectedCallback() {
      instances.delete(this);
      if (instances.size === 0) {
        document.removeEventListener('change', handleChange);
        document.removeEventListener('mm:shipping-destination', handleDestination);
      }
    }
    money(cents) {
      try {
        return new Intl.NumberFormat(this.dataset.locale || 'pt-BR', {style: 'currency', currency: 'BRL'}).format(cents / 100);
      } catch (_) {
        return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
      }
    }
    renderMessage(template, amount, state, showRegion = false) {
      const text = String(template || '').replaceAll('{state}', state || '');
      const parts = text.split('{amount}');
      const fragment = document.createDocumentFragment();
      parts.forEach((part, index) => {
        if (index > 0) {
          const value = document.createElement('strong');
          value.textContent = amount || '';
          fragment.append(value);
        }
        fragment.append(document.createTextNode(part));
      });
      if (showRegion && this.dataset.region) {
        const region = document.createElement('span');
        region.className = 'mm-fs__region';
        region.textContent = ' ' + this.dataset.region.replaceAll('{state}', state);
        fragment.append(region);
      }
      // Merchant messages remain text; never interpret HTML from the editor.
      this.messageEl.replaceChildren(fragment);
    }
    update(address) {
      const single = this.dataset.mode === 'single';
      const state = normalizeState(address.state || this.dataset.defaultState);
      const total = Number(this.dataset.cartTotal);
      const states = (this.dataset.states || '').split(',').map(normalizeState).filter(Boolean);
      this.trackEl.hidden = true;
      this.fillEl.style.width = '0%';
      if (!isBrazil(address.country) || this.dataset.currency !== 'BRL' || !Number.isFinite(total) || total < 0) {
        this.messageEl.textContent = this.dataset.other || '';
        return;
      }
      if (!single && !state) {
        this.messageEl.textContent = this.dataset.intro || '';
        return;
      }
      const amount = single ? Number(this.dataset.threshold) : state === 'SP' ? Number(this.dataset.sp) : states.includes(state) ? Number(this.dataset.group) : 0;
      const threshold = Math.round(amount * 100);
      if (!Number.isFinite(threshold) || threshold <= 0) {
        this.messageEl.textContent = this.dataset.other || '';
        return;
      }
      const remaining = Math.max(0, threshold - total);
      this.renderMessage(remaining === 0 ? this.dataset.success : this.dataset.progress,
        remaining === 0 ? '' : this.money(remaining), state, !single);
      this.trackEl.hidden = false;
      this.fillEl.style.width = Math.max(0, Math.min(100, total / threshold * 100)) + '%';
    }
  }
  customElements.define('mm-free-shipping-progress', MMFreeShippingProgress);
})();
